import React from "react";
import { useHistory } from "react-router-dom";
import logo from "../assets/ClapingoLogo.png";
import error from "../assets/error.png";


const EmailVerificationPage = () => {
    const history = useHistory();
    return (
        <div className="pt-5">
            <div className="text-center">
                <img src={logo} alt="logo" />
            </div>
            <div className="row">
                <div className="col-md-6">
                    <div className="ml-5 pl-5 mt-5">
                        <img src={error} alt="error" />
                    </div>
                </div>
                <div className="col-md-6">
                    <h2 style={{marginTop:"200px"}}>Unable to validate link!</h2>
                    <p>It looks like there is an issue with this email link.<br/> Please try again and we’ll send you a new link for<br/> verification.</p>
                    <button onClick={() => history.push("/login")} style={{background:"#4DC591",width: "175px", height: "48px", color:"white", borderRadius:"8px", border:"none"}}>Login</button>
                </div>
                
            </div>
        </div>
    );
};

export default EmailVerificationPage;
